import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PayperbyteWarnDialogComponent } from '../payperbyte-warn-dialog/payperbyte-warn-dialog.component';
import { CompanyDetailsService } from '../services/company-details.service';
import { LoaderService } from '../services/loader.service';
import { PaymentService } from '../services/payment.service';
import { UserService } from '../services/user.service';

import { MatSnackBar } from '@angular/material/snack-bar';
// import * as pdfMake from "pdfmake/build/pdfmake";
// import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { LogService } from '../services/log.service';
// (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

// const htmlToPdfmake = require("html-to-pdfmake");


@Component({
	selector: 'app-transaction-history',
	templateUrl: './transaction-history.component.html',
	styleUrls: ['./transaction-history.component.css']
})
export class TransactionHistoryComponent implements OnInit {
	public paymentHistory = [];
	public paymentGateway = '';
	public fullName = '';

	public company_initial = ""
	public company_logo = ""
	public company_name = ""
	public company_address = "";
	public studentData;

	constructor (public _loaderService: LoaderService,
		public dialog: MatDialog,
		public _paymentService: PaymentService,
		public _companyDetailsService: CompanyDetailsService,
		public _userService: UserService, public log: LogService,
		public _snackbar: MatSnackBar
	) { }

	ngOnInit () {
		this.log
			.addLog({
				action: "Access",
				component: "Transaction History",
				details: `Accessed Transaction History`,
			}).subscribe(data => { });
		this.getPaymentGateway();
		this.getUserData();
	}

	getTransactionHistory () {
		this._loaderService.emitChange(true);
		this._paymentService.transactionHistory().subscribe(data => {
			this._loaderService.emitChange(false);
			this.paymentHistory = data;
		})
	}

	getPaymentGateway () {
		this._companyDetailsService.getDetails().subscribe(data => {
			this.paymentGateway = data.payment_gateway;
			this.company_initial = data.adm_initial;
			this.company_logo = data.logo;
			this.company_name = data.name;
			this.company_address = data.address;
			this._userService.getUserData().subscribe(data => {
				this.fullName = `${data.lastname} ${data.firstname} ${data?.middlename ?? ''}`;
				this.studentData = data;
			})
			this.getTransactionHistory();
		})
	}

	getUserData () {
		this._userService.getUserData().subscribe(data => {
			this.fullName = data.firstname.toUpperCase() + " " + data.lastname.toUpperCase();
		})
	}

	viewSlip (slip) {
		this.dialog.open(PayperbyteWarnDialogComponent, {
			data: { for: 'view_image', image: slip }
		})
	}

	printPDF (payment) {
		this.log
			.addLog({
				action: "Print",
				component: "Transaction History",
				details: `Printed Transaction History`,
			}).subscribe(data => { });
		// let invoice = this.paymentHistory.filter(p => p.invoice_id == invoice_id)[0];
		let displayData = "";

		// this.company_logo =  this.getBase64ImageFromURL("https://edu.sqi.ng/wp-content/uploads/2019/01/co.jpg");

		var imgToExport: any = document.getElementById('imgToExport');
		var canvas = document.createElement('canvas');
		canvas.width = imgToExport.width;
		canvas.height = imgToExport.height;
		canvas.getContext('2d').drawImage(imgToExport, 0, 0);
		let url = canvas.toDataURL('image/png')

		// displayData += canvas;
		// displayData += `<img src="${this.company_logo}" />`;

		displayData +=
			`
      <h4 align="center">${this.company_name}</h4>
      <p><small>${this.company_address}</small></p>
      `

		displayData += `
      <p> 
          <b>Student Name: </b> <span style="text-transform: uppercase">${this.fullName} </span>
          <br> <b>Student ID: </b> ${this.studentData.matric_no}
          <br> <b>For: </b> ${payment.session_year} - ${payment.term}
          <br> <b>Status: </b>   <span > ${payment.status} </span>
          <br> <b>Reference: </b> ${payment.reference}
          <br> <b>Date: </b> ${payment.created_at}
      </p>

      <p style="font-size: 20pt"> Amount: ${payment.amount / 100} </p>
    `

		// var html = htmlToPdfmake(displayData);
		// const documentDefinition = { content: html };
		// pdfMake.createPdf(documentDefinition).download(`payment-${this.studentData.matric_no}`);
	}

	requery (payment) {
		this._loaderService.emitChange(true);
		this._paymentService.requeryTuitionPayment({ reference: payment.reference }).subscribe({
			next: (resp: any) => {
				this._loaderService.emitChange(false);
				if (resp.status) {
					this.log.addLog({
						action: "Requery",
						component: "Transaction History",
						details: `Requery Transaction: ${payment.reference}`,
					}).subscribe();

					this._snackbar.open("Transaction requeried!", "Dismiss", { duration: 4000 })
				} else {
					this._snackbar.open(resp.message ?? "An error occured", "Dismiss", { duration: 4000 })
				}

				this.getTransactionHistory();
			}, error: () => {
				this._loaderService.emitChange(false);
				this._snackbar.open("An error occured, please try again.", "Dismiss", { duration: 4000 })
			}
		})
	}
}
